import React from 'react';
import { Popover, Whisper } from 'rsuite';
import InfoIcon from '@mui/icons-material/Info';
import './AdditionalInfo.scss';

/**
 * @param {{children:*; visible?: boolean} & import('rsuite').WhisperProps} param0
 */
const AdditionalInfo = ({ children, visible, icon, ...other }) => (
    <div className={`core--additional-info ${typeof (visible) === 'undefined' || visible ? 'visible' : ''}`}>
        <Whisper
            placement="bottomEnd"
            speaker={
                <Popover
                    className="core--additional-info--popover"
                >
                    {children}
                </Popover>
            }
            {...other}
        >
            {icon ?? <InfoIcon />}
        </Whisper>
    </div>
);

export default AdditionalInfo;
